function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M384 128H256V0l128 128zm-128 32h128v304c0 26-22 48-48 48H48c-26 0-48-22-48-48V48C0 22 22 0 48 0h176v128c0 18 14 32 32 32zm-1 135l-39 39V232c0-13-11-24-24-24s-24 11-24 24v102l-39-39c-5-5-11-7-17-7s-12 2-17 7c-9 9-9 25 0 34l80 80c9 9 25 9 34 0l80-80c9-9 9-25 0-34s-25-9-34 0z"
});

function SvgFileArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512"
  }, props), _ref);
}

export default SvgFileArrowDown;